var isDev = process.env.HOST_ENV === 'development'  // 开发
var isTest = process.env.HOST_ENV === 'test' // 测试
var isPreTest = process.env.HOST_ENV === 'pretest' // 预发布
var isProduction = process.env.HOST_ENV === 'production' // 生产
var isBuild = process.env.NODE_ENV === 'production'
var env = process.env.HOST_ENV
var selfAppId = 'wxfd379eb51ca72f73' // 云娱智慧（theatreType=0 默认；旧火票 wx66e4368a1b2cf15f 已弃用）
var theatreType = 0   //0云娱 1丰马in剧场 2平阳剧院 3均州剧院 4天长 5东南 6靖江 7周市 8义乌 9温州高新 10金沙湖 11温岭大剧院  12泌阳大剧院  13天津滨海演艺中心 14天津音乐厅 15余姚大剧院 16大港大剧院 17泰兴苏利大剧院  18宁海文化中心 19普陀大剧院 20 北仑文化中心大剧院




var yxtPayAppId = 'wx22c08e1e85c92715' // 园秀通支付微信小程序appid
var tenantId = '9CE96639601E4E479A5BA9B037451169'
var clientId = 'd2bgi74zxipu' // 正式测试的
var clientSecret = 'yunyuzh@2020'
// var host = '//m.ihuopiao.com'
var host = 'https://api.ihuopiao.com'
var webhost = 'https://h5.ihuopiao.com'
var dramahost = 'https://merchant.ihuopiao.com'   

// host = 'https://hpm.api.ihuopiao.com'
// webhost = 'https://hp.m.ihuopiao.com'
// dramahost = 'https://hp.ihuopiao.com'


var ossHost = '//oss.52drama.com'
var resourceHost = '//res.52drama.com'           // 原剧汇王朝场馆信息的，已废弃
var userImgUrl = '//res.52drama.com'
var staticHost = '//static.52drama.com/wmini'
var ihuopiaoHost = '//static.52drama.com/ihuopiao'
var baiduAppKey = 'ce5dc8757c'
var shareTitle = '云娱智慧'

function getExtStoreId(type){
	try{
			const data = uni.getExtConfigSync ? uni.getExtConfigSync() : {}
      let extConfig = data.extConfig || {}
      // console.log('extConfig=======》',extConfig)
			return extConfig[type];
	}catch(err){
			console.log(err,'getExtStoreId__error')
	}
}

// isTest = false // 测试
// isDev = false
// isPreTest = false
if(theatreType && !isDev){
  if(theatreType === 1){
    selfAppId = 'wx558fe143732a60ae'
    clientId = 'eeefe04a-aa55-43e8-a9f9-a11dfcd20388' // 丰马的
    shareTitle = '丰马In剧场'
  }
  if(theatreType === 2){
    selfAppId = 'wx67a47455d25d7c26'
    clientId = '4cd766cb-874d-4b33-932f-5c7ed0da9093' // 平阳的
    shareTitle = '平阳文化艺术中心大剧院'
    yxtPayAppId = 'wx11218c2441a73faf'
  } 
  if(theatreType === 3){
    selfAppId = 'wxce79887dfacc0a1f'
    clientId = 'bfyd9ofoqo02' // 
    shareTitle = '均州剧院'
  }
  if(theatreType === 4){
    selfAppId = 'wxf1c64a825d2cec32'
    clientId = 'd448u96q5lvm' // 
    shareTitle = '天长市文化艺术中心大剧院'
  }
  if(theatreType === 5){
    selfAppId = 'wxb4c5d2ba603a03dd'
    clientId = 'd2bgzyx6opa9' // 
    shareTitle = '东南剧院'
  }
  if(theatreType === 6){
    selfAppId = 'wxb94d202ebc6d8a30'
    clientId = 'd447gr0r514y' // 
    shareTitle = '靖江大剧院'
  }
  if(theatreType === 7){
    selfAppId = 'wx95e325eb9d4382f3'
    clientId = 'd5xbc0a3xngi' // 
    shareTitle = '昆山周市文化艺术中心'
  }

  if(theatreType === 8){
    selfAppId = 'wx2c1f72fda548291f'
    clientId = '1747945850515529730' // 
    shareTitle = '义乌文化广场剧院'
  }


  if(theatreType === 9){
    selfAppId = 'wxed95ccc25f1984e6'
    clientId = 'd5x7h6pmrrwi' // 
    shareTitle = '温州高新文化广场'
  }

  if(theatreType === 10){
    // selfAppId = 'wxf186423ed34d058e'
    selfAppId = 'wx48ed6c4010316fb7' // 票务助手
    clientId = '1764467545732599809' // 
    shareTitle = '金沙湖大剧院'
  }

  if(theatreType === 11){
    selfAppId = 'wx306d5e4910a937e6'
    clientId = '1783016639467941889' // 
    shareTitle = '温岭大剧院'
  }

  if(theatreType === 12){
    selfAppId = 'wx96577b35c247b0b4'
    clientId = '1846390836409524225' // 
    shareTitle = '泌阳大剧院'
  }

  if(theatreType === 13){
    selfAppId = 'wx62fac3373ec1361d'
    clientId = '1845385787394875393' // 
    shareTitle = '天津滨海演艺中心'
  }

  if(theatreType === 14){
    selfAppId = 'wxa6d54a6f380918cf'
    clientId = '1845388443052007426' // 
    shareTitle = '天津音乐厅'
  }

  if(theatreType === 15){
    selfAppId = 'wx5f717d1929ae9b35'
    clientId = '1863501103777734657' // 
    shareTitle = '余姚大剧院'
  }

  if(theatreType === 16){
    selfAppId = 'wx944013a460767b88'
    clientId = '1845385993834323969' // 
    shareTitle = '大港大剧院'
  }
  
  if(theatreType === 17){
    selfAppId = 'wx7bbc9a7d01e7bf03'
    clientId = '1882258076962660353' // 
    shareTitle = '泰兴苏利大剧院'
  }

  if(theatreType === 18){
    selfAppId = 'wxedeb321f0434398c'
    clientId = '1788034297879916545' // 
    shareTitle = '宁海文化中心'
  }

  if(theatreType === 19){
    selfAppId = 'wxdb3809606e372a0d'
    clientId = '2061688491207491586' // 
    shareTitle = '普陀大剧院'
  }
  if(theatreType === 20){
    selfAppId = 'wxfa6f1b745a003aa0'
    clientId = '2069966813050781697' // 
    shareTitle = '北仑文化中心大剧院'
  }

}

















































if (isDev) {
  // clientId = 'e422870f-5e53-433e-a3d0-fb2e79d87afc'
  // clientId = '4cd766cb-874d-4b33-932f-5c7ed0da9093'   // 98fy0hcdkao2 98rpw81ucd8h 18268826992 开发商户  9pioax43oav5
  clientId = 'd1fkbhrh2tqa'
  // clientSecret = 'string'
  clientSecret = 'yunyuzh@2020'
  
  if(isBuild){
    // host = 'https://hpdevmapi.ngrok.yunyuzh.com'
    // webhost = 'https://hpdevm.ngrok.yunyuzh.com'
    host = 'http://hpdevm.api.ihuopiao.com'
    // webhost = 'http://hpdev.m.ihuopiao.com'
    webhost = 'http://hptest.m.ihuopiao.com'
  } else {
    host = 'http://hptestm.api.ihuopiao.com'
    // webhost = 'http://hpdev.m.ihuopiao.com'
    webhost = 'http://hptest.m.ihuopiao.com'
  }
  ossHost = '//oss-dev.52drama.com'
  resourceHost = '//resdev.52drama.com:24804'
  // staticHost = '//static-dev.52drama.com/wmini'
  dramahost = 'http://hptestk8s.ihuopiao.com'
  baiduAppKey = '7be63f1f0a'

  host = 'http://api-hp.test.ihuopiao.com'
  webhost = 'http://hp-h5.test.52drama.com'
  ossHost = '//oss-test.52drama.com'
}

// 简化现在有用的环境参数 20260522
if (!isDev && isTest) {
  clientId = 'd1fkbhrh2tqa'
  host = 'http://api-hp.test.ihuopiao.com'
  webhost = 'http://hp-h5.test.52drama.com'
  ossHost = '//oss-test.52drama.com'
}

if(isPreTest){
  clientId = 'd1fkbhrh2tqa' // yhw // '4cd766cb-874d-4b33-932f-5c7ed0da9093' 
  // host = 'https://hpprem.api.ihuopiao.com'
  // webhost = 'https://hppre.m.ihuopiao.com'
  // dramahost = 'https://hppre.ihuopiao.com'
  host = 'https://api.pre.ihuopiao.com'
  webhost = 'https://h5.pre.ihuopiao.com'
}

// 压测环境临时用一下
let isPerfTest = false
if(isPerfTest){
  clientId = 'd1fkbhrh2tqa'
  host = 'https://api.perf.ihuopiao.com'
  webhost = 'https://h5.perf.ihuopiao.com'
}


if (isProduction) {
  console.log = function () { }
  // console.warn = function () { }
  console.debug = function () { }
  console.error = function () { }
}
















var CHN = {} // 城市代码
module.exports = {
  env,
  isBuild,
  CHN,
  yxtPayAppId,
  tenantId: tenantId,
  clientId,
  clientSecret,
  host: host,
  webhost,
  dramahost,
  ossHost: ossHost,
  staticHost,
  resourceHost: resourceHost,
  userImgUrl: userImgUrl,
  isDev: isDev,
  isTest: isTest,
  appId: selfAppId,
  appKey: '',
  baiduAppKey,
  shareTitle,
  amapKey: 'f13a2862d4bce843b49badfd0fbab1b5', // gd地图微信小程序key
  homepage: '/pages/home/home',
  defaultImg: {
    iconCry: '/static/img/network_time_out_cry.png',
    icon_userHead_noLogin: '/static/img/icon_userHead_noLogin.png',
    icon_checked: '/static/img/icon_checked.png',
    icon_plus: '/static/img/icon_plus.png',
    icon_minus: '/static/img/icon_minus.png',
    icon_updown: '/static/img/icon_updown.png',
    icon_up_red: '/static/img/icon_up_red.png',
    icon_down_red: '/static/img/icon_down_red.png',
    icon_cancel_gray: '/static/img/icon_cancel_gray.png',

    icon_toRight: '/static/img/icon_toRight.png',

    picError78X106: '/static/img/picError78X106.png',
    picError345X177: '/static/img/picError345X177.png',
    icon_checkedSeat: '/static/img/icon-checkedSeat.png',
    tab_checked: '/static/img/checked.png',
    icon_position_bg: '/static/img/icon_position_bg.png',
    icon_position: '/static/img/icon_position.png',

    bg_address:ihuopiaoHost +'/img/bg_address.png',
    bg_brithday_bottom:ihuopiaoHost +'/img/bg_brithday_bottom.png',
    bg_brithday_page:ihuopiaoHost +'/img/bg_brithday_page.png',
    bg_brithday_top:ihuopiaoHost +'/img/bg_brithday_top.png',
    bg_coupon_card:ihuopiaoHost +'/img/bg_coupon_card.png',
    bg_festival_bottom:ihuopiaoHost +'/img/bg_festival_bottom.png',
    bg_festival_page:ihuopiaoHost +'/img/bg_festival_page.png',
    bg_festival_top:ihuopiaoHost +'/img/bg_festival_top.png',
    bg_member_bottom:ihuopiaoHost +'/img/bg_member_bottom.png',
    bg_member_page:ihuopiaoHost +'/img/bg_member_page.png',
    bg_member_top:ihuopiaoHost +'/img/bg_member_top.png',
    bg_timeActivity:ihuopiaoHost +'/img/bg_timeActivity.png',
    image_gift0:ihuopiaoHost +'/img/image_gift0.png',
    image_gift1:ihuopiaoHost +'/img/image_gift1.png',
    image_gift2:ihuopiaoHost +'/img/image_gift2.png',
    image_noActivity2:ihuopiaoHost +'/img/image_noActivity2.png',
    image_obj0:ihuopiaoHost +'/img/image_obj0.png',
    image_obj1:ihuopiaoHost +'/img/image_obj1.png',
    image_obj2:ihuopiaoHost +'/img/image_obj2.png',
    image_time0:ihuopiaoHost +'/img/image_time0.png',
    image_time1:ihuopiaoHost +'/img/image_time1.png',
    image_time2:ihuopiaoHost +'/img/image_time2.png',
    img_birthday_enter:ihuopiaoHost +'/img/img_birthday_enter.png',
    img_birthday_left:ihuopiaoHost +'/img/img_birthday_left.png',
    img_coupon_top:ihuopiaoHost +'/img/img_coupon_top.png',
    img_festival_enter:ihuopiaoHost +'/img/img_festival_enter.png',
    img_member:ihuopiaoHost +'/img/img_member.png',
    img_member_enter:ihuopiaoHost +'/img/img_member_enter.png',
    noAddress:ihuopiaoHost +'/img/noAddress.png',
    noBanances:ihuopiaoHost +'/img/noBalance.png',
    noCards:ihuopiaoHost +'/img/noCards.png',
    order_top_bg:ihuopiaoHost +'/img/order_top_bg.png',

	  icon_duihao: '/static/img/icon_duihao.png',
	  icon_gantan: '/static/img/icon_gantan.png',
    icon_gantan2: '/static/img/icon_gantan2.png',
    icon_duihao_b: '/static/img/icon_duihao_b.png',
	
    bg_VIP1: ihuopiaoHost + '/VIP1.png',
    bg_VIP2: ihuopiaoHost + '/VIP2.png',
    bg_VIP3: ihuopiaoHost + '/VIP3.png',
    bg_VIP4: ihuopiaoHost + '/VIP4.png',
    bg_VIP5: ihuopiaoHost + '/VIP5.png',
    bg_VIP6: ihuopiaoHost + '/VIP6.png',
    bg_VIP7: ihuopiaoHost + '/VIP7.png',
    bg_VIP8: ihuopiaoHost + '/VIP8.png',
    bg_VIP9: ihuopiaoHost + '/VIP9.png',
    bg_VIP10: ihuopiaoHost + '/VIP10.png',

    image_noActivity:ihuopiaoHost +'/mini/no-activity.png',
    balanceBaner:ihuopiaoHost +'/mini/balanceBaner.png',
    bg_login:ihuopiaoHost +'/mini/bg_login.png',
    bindSuccess:ihuopiaoHost +'/mini/bindSuccess.png',
    image_activityTop:ihuopiaoHost +'/mini/image_activityTop.png',
    image_noShow:ihuopiaoHost +'/mini/image-noShow.png',
    integralBg:ihuopiaoHost +'/mini/integral_bg.png',
    noBalace:ihuopiaoHost +'/mini/noBalace.png',
    noBalanceDetail:ihuopiaoHost +'/mini/noBalanceDetail.png',
    nocard:ihuopiaoHost +'/mini/nocard.png',
    no_order_list:ihuopiaoHost +'/mini/no-order-list.png',
    image_noTicket:ihuopiaoHost +'/mini/no-ticket-wallet.png',
    order_confirm_bk:ihuopiaoHost +'/mini/order-confirm-bk.png',
    icon_float_moreShow:ihuopiaoHost +'/mini/icon-float-moreShow.png',
    icon_float_userCenter:ihuopiaoHost +'/mini/icon-float-userCenter.png',
    icon_float_userCenterHide:ihuopiaoHost +'/mini/icon-float-userCenterHide.png',
    QR_xiaochengxu_big:ihuopiaoHost +'/mini/QR_xiaochengxu_big.png',
    has_lost:ihuopiaoHost +'/mini/has-lost.png',
    has_refund:ihuopiaoHost +'/mini/has-refund.png',
    has_time_out:ihuopiaoHost +'/mini/has-time-out.png',
    has_used:ihuopiaoHost +'/mini/has-used.png',
    no_used:ihuopiaoHost +'/mini/no-used.png',
    pay_success:ihuopiaoHost +'/mini/pay-success.png',
    has_be_get: '/static/img/image-geted.png',
    has_be_used: '/static/img/image-used.png',
    has_be_timeout: '/static/img/image-timeout.png',
    has_be_refund: '/static/img/image-refund.png',
    image_timeout:'/static/img/image-timeout.png',
    image_haveUsed:'/static/img/image-haveUsed.png',
    image_stop:'/static/img/image-stop.png',
    image_unuseful:'/static/img/image-unuseful.png',
    image_over:'/static/img/image-over2.png',
    image_over3:'/static/img/image-over3.png',
    image_goods:'/static/img/image-goods2.png',
    image_goods3:'/static/img/image-goods3.png',
    icon_changguan:'/static/img/icon-changguan.png',
    icon_changguan_active:'/static/img/icon-changguan-active.png',
    icon_rili:'/static/img/icon-rili.png',
    icon_rili_active:'/static/img/icon-rili-active.png',

    navIcon1:ihuopiaoHost +'/img/nav-icon-h1.png',
    navIcon2:ihuopiaoHost +'/img/nav-icon-h2.png',
    navIcon3:ihuopiaoHost +'/img/nav-icon-h3.png',
    navIcon4:ihuopiaoHost +'/img/nav-icon-h4.png',
    navIconN1:ihuopiaoHost +'/img/nav-icon-n1.png',
    navIconN2:ihuopiaoHost +'/img/nav-icon-n2.png',
    navIconN3:ihuopiaoHost +'/img/nav-icon-n3.png',
    navIconN4:ihuopiaoHost +'/img/nav-icon-n4.png',
    navIconN5:ihuopiaoHost +'/img/nav-icon-n5.png',
    navIconN5:ihuopiaoHost +'/img/nav-icon-n5.png',
    homeLimitbg:ihuopiaoHost +'/img/home-limit-bg.png',
    myTopbg:ihuopiaoHost +'/img/my-top-bg.png',
    couponbg:ihuopiaoHost +'/img/coupon-bg.png',
    lipingkabg:ihuopiaoHost +'/img/lipingka-bg.png',
    limitBuyBtn:'/static/img/limit-buy-btn.png',
    couponBg:ihuopiaoHost + '/img/coupon-list-bg.png',
    limitBuyBtn2:ihuopiaoHost + '/img/limit-buy-btn.png',
    
    vipBg:ihuopiaoHost +'/img/vip-bg.png',
    vipBg0:ihuopiaoHost +'/img/vip-bg0.png',
    vipBg1:ihuopiaoHost +'/img/vip-bg1.png',
    vipBg2:ihuopiaoHost +'/img/vip-bg2.png',
    vipBg3:ihuopiaoHost +'/img/vip-bg3.png',
    vipBg4:ihuopiaoHost +'/img/vip-bg4.png',
    vipBg5:ihuopiaoHost +'/img/vip-bg5.png',
    vipBg6:ihuopiaoHost +'/img/vip-bg6.png',
    vipBg7:ihuopiaoHost +'/img/vip-bg7.png',
    vipBg8:ihuopiaoHost +'/img/vip-bg8.png',
    vipBg9:ihuopiaoHost +'/img/vip-bg9.png',
    vipBg10:ihuopiaoHost +'/img/vip-bg10.png',
  },
  // ShareMessage: {
  //   title: '火票', // 当前小程序名称
  //   desc: '火票', // 描述
  //   // imageUrl: staticHost + '/img/share_friends.png', // 自定义图片路径，可以是本地文件路径、代码包文件路径或者网络图片路径，支持PNG及JPG，不传入 imageUrl 则使用默认截图。显示图片长宽比是 5:4
  //   path: '/pages/index/index' // 当前页面 path ，必须是以 / 开头的完整路径
  // },
  allitemList:[
    {
        name:'全部',
        checked:true,
        value:null
    },{
        name:'音乐会',
        checked:false,
        value:14
    },{
        name:'儿童剧',
        checked:false,
        value:5
    },{
        name:'芭蕾',
        checked:false,
        value:6
    },{
        name:'交响乐',
        checked:false,
        value:7
    },{
        name:'话剧',
        checked:false,
        value:8
    },{
        name:'音乐剧',
        checked:false,
        value:2
    },{
        name:'歌剧',
        checked:false,
        value:1
    },{
        name:'戏剧',
        checked:false,
        value:15
    },{
        name:'舞剧',
        checked:false,
        value:3
    },{
        name:'演唱会',
        checked:false,
        value:13
    },{
        name:'相声曲艺',
        checked:false,
        value:9
    },{
        name:'马戏',
        checked:false,
        value:10
    },{
        name:'杂技',
        checked:false,
        value:11
    },{
        name:'魔术',
        checked:false,
        value:12
    },{
      name:'Livehouse',
      checked:false,
      value:16
    },{
        name:'其他',
        checked:false,
        value:999999
    },
  ],
  ShareMessage: {
    title: shareTitle, // 当前小程序名称
    desc: shareTitle, // 描述
    // imageUrl: staticHost + '/img/share_friends.png', // 自定义图片路径，可以是本地文件路径、代码包文件路径或者网络图片路径，支持PNG及JPG，不传入 imageUrl 则使用默认截图。显示图片长宽比是 5:4
    path: '/pages/index/index' // 当前页面 path ，必须是以 / 开头的完整路径
  },
  toastDuration: 1500,
  // 错误消息提示时间
  errorMsgDuration: 4000,
  // 收藏，取消提示时间
  errorMsgDurationForCollect: 1500,
  // 切换身份，提示时间
  chooseIdentityDuration: 2000,
  // token过期重新获取次数
  refreshTokenTimes: 1,
  refreshTokenBeforeSec: 60, // 授权到期前多少秒开始再次申请授权
  // oss文件存储的目录定义
  ossFilePaths: {
    payimage: 'payimage', // 支付凭证图片
    userlogo: 'userlogo', // 用户头像
    idinfo:'idinfo',// 身份信息
  },
  reverseProxyAlias: {
    identityCenterAPI: '/ia',
    userCenterAPI: '/uc',
    userCenterMiddleAPI: '/ucm',
    systemBackAPI: '/sys',
    enterpriseManageAPI: '/om',
    theaterInfoAPI: '/thi',
    troupeInfoAPI: '/tri',
    scheduleBookingAPI: '/book',
    mixSearchAPI: '/mix',
    interactAPI: '/ita',
  }
}
